export default __webpack_public_path__ + "static/16594-e26c72c02153b7f3cd9ef54fa94a18d6.jpg";